import setValue from '../../shared/actions/setValue'
export const OPTIONS_VALUES = 'optionsValues'

const setOptionsValue = (data, dispatch, state) => {
  const oldValues = state.main[OPTIONS_VALUES] || {};

  if (data) {
    dispatch(setValue(OPTIONS_VALUES, {
      ...oldValues,
      ...data
    }))
  } else {
    dispatch(setValue(OPTIONS_VALUES, null))
  }
}
export default (data) => (
  dispatch, getState,
) => setOptionsValue(data, dispatch, getState())
